/** @jsxImportSource @emotion/react */
import { Global, css } from "@emotion/react";
import React from "react";
import { theme, themeTwo } from "./theme";
import { REACT_APP_NEW_THEME } from "services/config";

const hostname = typeof window !== "undefined" ? window.location.hostname : "";

const _theme = hostname.includes(REACT_APP_NEW_THEME) ? themeTwo : theme;

const GlobalStyles: React.FC = () => (
  <Global
    styles={css`
      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte.otf")
          format("opentype");
        font-weight: normal;
        font-style: normal;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-LightItalic.otf")
          format("opentype");
        font-weight: 300;
        font-style: italic;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte Medium.otf")
          format("opentype");
        font-weight: 500;
        font-style: normal;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte Semibold.otf")
          format("opentype");
        font-weight: 600;
        font-style: normal;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte Bold.otf")
          format("opentype");
        font-weight: 700;
        font-style: normal;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-RegularItalic.otf")
          format("opentype");
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-LightItalic.otf")
          format("opentype");
        font-weight: 300;
        font-style: italic;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-MediumItalic.otf")
          format("opentype");
        font-weight: 500;
        font-style: italic;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-SemiboldItalic.otf")
          format("opentype");
        font-weight: 600;
        font-style: italic;
      }

      @font-face {
        font-family: "Volte";
        src: url("../assets/fonts/Indian Type Foundry - Volte-BoldItalic.otf")
          format("opentype");
        font-weight: 700;
        font-style: italic;
      }

      body {
        margin: 0;
        padding: 0;
        font-family: "Volte", sans-serif;
        background-color: ${_theme.colors.background};
        primary-color: ${_theme.colors.primary};
      }

      .active {
        border-bottom: 0px solid;
      }

      .brandPrimaryBtn {
        background-color: ${_theme.colors.primary};
        :hover {
          background-color: ${_theme.colors.primary};
        }
      }

      .radio-group > div > div > button[data-state="checked"] {
        background-color: ${_theme.colors.primary};
        border: none;
      }
      
      .radio-group-dropdown > div > div {
        align-items: center;
        label > div {
          height: auto;

        }
      }
       .loaderPage{
        height:100%;
        width:100%;
        margin:0px;
       } 
      .yarl__navigation_prev {
        display:none;
      }
      .yarl__navigation_next{
         display:none;
      }
         .yarl__portal {
        z-index: 10000
        }

       body > div[data-state="open"] {
        z-index: 1000;
      }
      body > div[role="alertdialog"] {
        z-index: 1000;
      }
      body > div[role="alertdialog"].hide-dialog,
      body > div[data-state="open"].hide-dialog {
        visibility: hidden;
        transition: visibility 0s 0.1s;
      }

    `}
  />
);

export default GlobalStyles;
